import { PaymentApi } from '../../generated/api';
import configuration from './configuration';

export default new PaymentApi(configuration);
